var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from './model';
import DtoConverter from '../core/utils/dto-converter';
import { Part } from './part';
import { ProductItemPrice } from './product-item-price';
import { Translation } from './translation';
var ProductItem = /** @class */ (function (_super) {
    __extends(ProductItem, _super);
    function ProductItem(data) {
        var _this = _super.call(this, data) || this;
        if (data.matboard) {
            _this.matboard = new Part(data.matboard);
        }
        if (data.virtual_matboard) {
            _this.virtual_matboard = new Part(data.virtual_matboard);
        }
        if (data.frame) {
            _this.frame = new Part(data.frame);
        }
        if (data.photo_print) {
            _this.photo_print = new Part(data.photo_print);
        }
        if (data.translations) {
            _this.translations = DtoConverter.createList(Translation, data.translations);
        }
        if (data.prices) {
            _this.prices = DtoConverter.createList(ProductItemPrice, data.prices);
        }
        return _this;
    }
    ProductItem.prototype.getPrice = function () {
        var _a;
        if (!((_a = window.App) === null || _a === void 0 ? void 0 : _a.locale.currencyId)) {
            throw new Error('Global locale settings are missing');
        }
        if (!this.prices) {
            return 0;
        }
        var price = this.prices.find(function (item) { return item.currency_id === window.App.locale.currencyId; });
        if (!price) {
            throw new Error('Product item has no price');
        }
        return price.price;
    };
    ProductItem.prototype.getMatboardSizes = function (orientation, maxWidth, maxHeight) {
        if (this.virtual_matboard) {
            return this.virtual_matboard.getBorderSizes(orientation, maxWidth, maxHeight);
        }
        if (this.matboard) {
            return this.matboard.getBorderSizes(orientation, maxWidth, maxHeight);
        }
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        };
    };
    ProductItem.prototype.getSizesInInch = function (orientation) {
        var originalInnerSizes = this.getOriginalInnerSizes(orientation);
        if (!originalInnerSizes) {
            return null;
        }
        var width = originalInnerSizes.width / 10 / 2.54;
        var height = originalInnerSizes.height / 10 / 2.54;
        return {
            width: width,
            height: height,
        };
    };
    ProductItem.prototype.getOriginalInnerSizes = function (orientation) {
        if (this.virtual_matboard) {
            return this.virtual_matboard.getOriginalInnerSizes(orientation);
        }
        if (this.photo_print) {
            return this.photo_print.getOriginalInnerSizes(orientation);
        }
        if (this.frame) {
            return this.frame.getOriginalInnerSizes(orientation);
        }
        return null;
    };
    ProductItem.prototype.getInnerSize = function (orientation, maxWidth, maxHeight) {
        var outerSize = this.getOuterSize(orientation, maxWidth, maxHeight);
        var frameSizes = this.getFrameSizes(orientation, maxWidth, maxHeight);
        var matboardSizes = this.getMatboardSizes(orientation, maxWidth, maxHeight);
        if (!outerSize || !frameSizes || !matboardSizes) {
            return null;
        }
        var innerWidth = outerSize.width - frameSizes.left - frameSizes.right - matboardSizes.left - matboardSizes.right;
        var innerHeight = outerSize.height - frameSizes.top - frameSizes.bottom - matboardSizes.top - matboardSizes.bottom;
        return {
            width: innerWidth,
            height: innerHeight,
        };
    };
    ProductItem.prototype.getInnerSizeWithoutFrame = function (orientation, maxWidth, maxHeight) {
        var outerSize = this.getOuterSize(orientation, maxWidth, maxHeight);
        var matboardSizes = this.getMatboardSizes(orientation, maxWidth, maxHeight);
        if (!outerSize || !matboardSizes) {
            return null;
        }
        var innerWidth = outerSize.width - matboardSizes.left - matboardSizes.right;
        var innerHeight = outerSize.height - matboardSizes.top - matboardSizes.bottom;
        return {
            width: innerWidth,
            height: innerHeight,
        };
    };
    ProductItem.prototype.getOuterSize = function (orientation, maxWidth, maxHeight) {
        if (this.frame) {
            return this.frame.getOuterSize(orientation, maxWidth, maxHeight);
        }
        if (this.virtual_matboard) {
            return this.virtual_matboard.getOuterSize(orientation, maxWidth, maxHeight);
        }
        if (this.matboard) {
            return this.matboard.getOuterSize(orientation, maxWidth, maxHeight);
        }
        if (this.photo_print) {
            return this.photo_print.getOuterSize(orientation, maxWidth, maxHeight);
        }
        return null;
    };
    ProductItem.prototype.getOuterSizeWithoutFrame = function (orientation, maxWidth, maxHeight) {
        if (this.frame) {
            return this.frame.getInnerSize(orientation, maxWidth, maxHeight);
        }
        if (this.matboard) {
            return this.matboard.getOuterSize(orientation, maxWidth, maxHeight);
        }
        if (this.virtual_matboard) {
            return this.virtual_matboard.getOuterSize(orientation, maxWidth, maxHeight);
        }
        if (this.photo_print) {
            return this.photo_print.getOuterSize(orientation, maxWidth, maxHeight);
        }
        return null;
    };
    ProductItem.prototype.getFrameSizes = function (orientation, maxWidth, maxHeight) {
        if (this.frame) {
            return this.frame.getBorderSizes(orientation, maxWidth, maxHeight);
        }
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        };
    };
    return ProductItem;
}(Model));
export { ProductItem };
